// extracted by mini-css-extract-plugin
var _1 = "EmbedPostContent-module__animatedBackground--UFqdj";
var _2 = "EmbedPostContent-module__container--OG5B7";
var _3 = "660px";
var _4 = "EmbedPostContent-module__hasFooter--YV7TY";
var _5 = "EmbedPostContent-module__inner--zaIY2";
var _6 = "EmbedPostContent-module__overlay--oBGh0";
var _7 = "EmbedPostContent-module__stateBar--oqDAa";
var _8 = "EmbedPostContent-module__tocContainer--kLnz7";
var _9 = "EmbedPostContent-module__tocTitle--DNlbg";
var _a = "EmbedPostContent-module__tocWrapper--ISpel";
export { _1 as "animatedBackground", _2 as "container", _3 as "contentMaxWidth", _4 as "hasFooter", _5 as "inner", _6 as "overlay", _7 as "stateBar", _8 as "tocContainer", _9 as "tocTitle", _a as "tocWrapper" }
